"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
/**
 * Scroll to top button at the bottom of the screen
 */
var ScrollToTop = /** @class */ (function (_super) {
    __extends(ScrollToTop, _super);
    function ScrollToTop() {
        var _this = _super.call(this, constants_1.DATA_SCROLL_TO_TOP) || this;
        _this.scrollOffset = 300;
        if (!_this.getElement())
            return _this;
        _this.initEventListeners();
        // Check scroll on page load
        _this.checkOffset();
        return _this;
    }
    /**
     * Init listeners
     * @private
     */
    ScrollToTop.prototype.initEventListeners = function () {
        var _this = this;
        this.getElement().addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
        window.addEventListener('scroll', function () {
            _this.checkOffset();
        });
    };
    /**
     * Check if user has scrolled
     * @private
     */
    ScrollToTop.prototype.checkOffset = function () {
        if (window.scrollY > this.scrollOffset) {
            this.getElement().classList.add(constantsClasses_1.CLASS_ACTIVE);
        }
        else {
            this.getElement().classList.remove(constantsClasses_1.CLASS_ACTIVE);
        }
    };
    return ScrollToTop;
}(AbstractComponent_1.default));
exports.default = ScrollToTop;
